import {
  Field,
  FieldControl,
  FieldIcon,
  FieldLabel,
  TextArea,
} from "@prismicio/editor-ui"
import type { TextContent } from "@prismicio/types-internal/lib/content"
import type { Text } from "@prismicio/types-internal/lib/customtypes"
import type { ReactNode } from "react"

import { getFieldLabel, getFieldPlaceholder } from "./utils"

interface Props {
  content: TextContent | undefined
  field: Text
  id: string
  onContentChange: (content: TextContent | undefined) => void
  readOnly: boolean
  endAdornment?: ReactNode
  placeholder?: string
}

export function KeyTextField(props: Props) {
  const {
    content,
    field,
    id,
    onContentChange,
    readOnly,
    endAdornment,
    placeholder,
  } = props

  return (
    <Field>
      <FieldIcon name="notes" />
      <FieldLabel htmlFor={id}>{getFieldLabel(field)}</FieldLabel>
      <FieldControl>
        <TextArea
          id={id}
          placeholder={placeholder || getFieldPlaceholder(field)}
          readOnly={readOnly}
          paddingLeft={4}
          paddingRight={12}
          sx={{ flexGrow: 1 }}
          value={content?.value ?? ""}
          onChange={(value) => {
            onContentChange(updateContent(value))
          }}
        />
        {endAdornment}
      </FieldControl>
    </Field>
  )
}

function updateContent(value: string): TextContent | undefined {
  return value.length === 0
    ? undefined
    : { __TYPE__: "FieldContent", type: "Text", value }
}
